import React from "react";
import {createUseStyles} from "react-jss";
import clsx from "clsx";

const useStyles = createUseStyles({
    svg: {
        fill:"none",
        stroke: props => props.color ?? "#9ACED9",
        strokeLinecap: "round",
    },
    st0: {
        strokeDasharray: 2
    },
    st1: {
        strokeWidth: 2,
    }
});

type RankArrowIconProps = {
    color?:string
    className?:string
}

export default function RankArrowIcon(props:RankArrowIconProps){
    const classes = useStyles(props);
    return (
        <svg className={clsx(classes.svg, props.className)} viewBox="0 0 16 20">
            <g>
                <line className={classes.st0} x1="2" y1="10" x2="9" y2="3"/>
                <line className={classes.st0} x1="9" y1="3" x2="16" y2="10"/>
            </g>
            <g>
                <line className={classes.st1} x1="4" y1="13" x2="9" y2="8"/>
                <line className={classes.st1} x1="9" y1="8" x2="14" y2="13"/>
                <line className={classes.st1} x1="9" y1="9" x2="9" y2="20"/>
            </g>
        </svg>
    );
}